import { User } from "types";

/**
 * Color from Id
 */
export function strToNum(str: string) {
  let num = 0;
  for (let i = 0; i < str?.length || 0; i++) {
    num = str.charCodeAt(i) + ((num << 5) - num);
  }
  return num;
}

export function color(str: string) {
  const num = strToNum(str);
  return `hsl(${~~(num % 360)},70%,70%)`;
}

type Params = Record<string, string>;

export function extractFromQuery<P extends object = Params>(query: string) {
  const result = {} as P;
  const str = query.startsWith("?") ? query.slice(1) : query;
  const parts = str.split("&");
  const pairs = parts.map((part) => part.split("="));

  for (const [key, value] of pairs) {
    const k = decodeURIComponent(key) as keyof P;
    const v = decodeURIComponent(value) as unknown as P[keyof P];
    result[k] = v;
  }

  return result;
}

export function displayUser(user: User) {
  return user?.firstName
    ? `${user.firstName} ${user?.lastName || ""}`
    : user && user?.email
      ? user!.email
      : null;
}

export function secondsToMinutes(sec: number) {
  // Calculate minutes and remaining seconds
  const minutes = Math.floor(sec / 60);
  const seconds = (sec % 60).toFixed(0);

  // Convert minutes and seconds to strings and add leading zeros if needed
  const minutesStr = String(minutes).padStart(2, "0");
  const secondsStr = String(seconds).padStart(2, "0");

  // Return the time in mm:ss format
  return `${minutesStr}:${secondsStr}`;
}

export function formatTimeToAM(date: Date) {
  const theDate = new Date(date);
  let hours = theDate.getHours();
  const minutes = theDate.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  // // Convert to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12;
  const minString = minutes < 10 ? "0" + minutes : minutes.toString();

  const strTime = hours + ":" + minString + " " + ampm;
  return strTime;
}

export const extractMeetingLocation = (location: string) => {
  if (location?.includes("http")) {
    return location?.split("/")[2]?.split(".")?.slice(-2)?.join(".") || "";
  }
  return location;
};

export const isBetaUser = (user: string) => {
  const betaUsers = [
    "6682b798ba35da9fbdd685a6", // djibril.issoufou@multiplayer.work
    "66f43bf41b53993eca10abb2", // craig.hosang@multiplayer.work
    "668c76d873eff9d43033f912",
    "66ba399d353764d12439bd03",
    "66d8c42a44a130c00d62418e",
    "6682d86df4401cc0f20882c8",
    "67ac6b90dfdadb12eb29b83a",
    "67db59cccf863f6c760d69a7",
    "66ea02d2fe698d7fb13a98da",
    "67e19a32a16c56a108052ea9",
    "67a26beb859c1a547c84899a", // elizabeth keen
    "67fffa263d44ef51f8b1341f", // zoom user
  ];
  return betaUsers.includes(user?.toString());
};

export function isPersonalEmail(email: string) {
  const isPersonalEmailRegex =
    /@(gmail|yahoo|hotmail|yahoo|aol|abc|xyz|pqr|rediffmail|live|outlook|me|msn|ymail)\.com$/;
  return isPersonalEmailRegex.test(email);
}
